<template>
  <div>
    <div class="bg">
      <div class="ms">
        相似度匹配，与已有商户名称不一致的是指，排除省市区信息后，名称不一致
      </div>
      <hm-step :steps="steps" :step="step" :disabled-jump="true"></hm-step>
    </div>
    <hm-content class="mt10">
      <div class="title">
        {{ title }}
      </div>
      <div v-if="step == 1">
        <div class="flex flex-between item-center">
          <div class="orange ml10">
            检查商户信息后，保留数据到步骤④门店核对再处理
          </div>
          <div style="font-size: 16px">
            数量：{{ duplicateStoreList.length }}
          </div>
        </div>
        <div class="mt20">
          <el-table
            :data="duplicateStoreList"
            border
            stripe
            size="small"
            style="width: 100%"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="360"
              :index="index => index + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="storeName"
              label="商户名称"
            >
            </el-table-column>
          </el-table>
        </div>
        <!--<div class="hm-pagination">
          <el-pagination
              background
              :total="duplicateTotal"
              @current-change="paging"
              @size-change="handleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPage"
          ></el-pagination>
        </div>-->
        <div class="mt40 flex flex-center item-center">
          <el-button type="primary" size="small" @click="next(2)">
            保留数据到门店核对</el-button
          >
        </div>
      </div>
      <div v-if="step == 2">
        <div class="orange ml10">
          商户信息处理后，新增商户连带门店到步骤③一起导入，匹配已有商户的商户信息将保留数据到步骤④门店核对再处理
        </div>
        <div class="flex mt20">
          <div style="width: 30%">
            <div class="step2-Ms">
              已处理/总数量：{{ likeSolve }}/<span>{{ likeList.length }}</span>
            </div>
            <div class="flex mt10">
              <div style="width: 90%">
                <el-table
                  :data="likeList"
                  ref="likeTable"
                  border
                  :row-class-name="tableRowClassName"
                  :height="500"
                  size="small"
                  style="width: 100%"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="storeName"
                    label="商户名称"
                  >
                    <template slot-scope="scope">
                      <div style="padding-left: 20px">
                        {{ scope.row.storeName }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="storeAddress"
                    label="商户地址"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    width="80px"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        class="blue"
                        size="small"
                        v-if="scope.row.type"
                        @click="step2Rollback(scope.row, scope.$index)"
                        >撤销</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="flex-1 flex flex-center">
                <div
                  class="hmicon icon-youshuangjiantou1"
                  style="margin-top: 150px"
                ></div>
              </div>
            </div>
          </div>
          <div style="width: 70%" v-if="likeSolve < likeList.length">
            <div class="step2-Ms">
              {{ likeList[0].storeName
              }}<span style="font-size: 14px">（默认显示相似度top5数据）</span>
            </div>
            <div class="mt10">
              <el-button type="primary" size="small" @click="likeViewAdd">
                新增商户</el-button
              >
            </div>
            <div class="mt20">
              <el-table
                :data="likeStoreList"
                border
                stripe
                size="small"
                style="width: 100%"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  type="index"
                  label="序号"
                  width="55"
                  :index="index => index + (currentPage - 1) * pageSize + 1"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="storeName"
                  label="商户名称"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="rewardNum"
                  label="当前活动数"
                >
                  <template slot-scope="scope">
                    <div class="blue pointer" @click="goAct(scope.row)">
                      {{ scope.row.rewardNum }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="rewardMoney"
                  label="累计红包金额"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="similarity"
                  label="相似度"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="address"
                  width="180"
                  label="操作"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center">
                      <el-button
                        size="small"
                        type="text"
                        @click="likeViewEdit(scope.row)"
                        >匹配该商户</el-button
                      >
                      <el-button
                        size="small"
                        type="text"
                        @click="catShop(scope.row)"
                        >查看门店</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div
            class="flex-1"
            style="margin-top: 28px"
            v-if="likeSolve >= likeList.length"
          >
            <div class="likeOver flex flex-center item-center">
              <div>
                <div class="text-center">
                  <img
                    src="https://imgcdn.hemiao100.com/ThemePictures/901144135.png"
                  />
                </div>

                <div style="font-size: 14px; color: #999999;">
                  当前页面商户已处理完毕，可以继续下一步操作
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt40 flex flex-center item-center">
          <el-button type="primary" size="small" @click="last(1)">
            上一步</el-button
          >
          <el-button
            type="primary"
            size="small"
            :disabled="likeSolve < likeList.length"
            @click="next(3)"
          >
            下一步</el-button
          >
        </div>
      </div>
      <div v-if="step == 3">
        <div class="flex flex-between item-center">
          <div class="orange ml10">商户及门店信息直接导入</div>
          <div class="flex item-center">
            <div class="mr20" style="font-size: 16px">
              新增商户数：{{ notExistStoreList.length }} / 已有商户数：{{
                duplicateStoreList.length
              }}
            </div>
            <el-button type="primary" size="small" @click="output">
              导出</el-button
            >
          </div>
        </div>
        <div class="mt20">
          <el-table
            :data="notExistStoreList"
            border
            stripe
            size="small"
            style="width: 100%"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="360"
              :index="index => index + (currentPage - 1) * pageSize + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="storeName"
              label="商户名称"
            >
            </el-table-column>
          </el-table>
        </div>
        <!--<div class="hm-pagination">
          <el-pagination
              background
              :total="notExistTotal"
              @current-change="paging"
              @size-change="handleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPage"
          ></el-pagination>
        </div>-->
        <div class="mt40 flex flex-center item-center">
          <el-button type="primary" size="small" @click="last(2)">
            上一步</el-button
          >
          <el-button type="primary" size="small" @click="next(4)">
            导入并下一步</el-button
          >
        </div>
      </div>
      <div v-if="step == 4">
        <div class="orange ml10">已匹配的商户进行门店核对再确认</div>
        <div class="flex mt20">
          <div style="width: 30%">
            <div class="step2-Ms">
              已处理/总数量：{{ duplicateSolve }}/<span>{{
                duplicateStoreList.length
              }}</span>
            </div>
            <div class="flex mt10">
              <div style="width: 90%">
                <el-table
                  :data="duplicateStoreList"
                  border
                  :row-class-name="tableRowClassName"
                  :height="500"
                  size="small"
                  style="width: 100%"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="storeName"
                    label="商户名称"
                  >
                    <template slot-scope="scope">
                      <div style="padding-left: 20px">
                        {{ scope.row.storeName }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="storeAddress"
                    label="商户地址"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    width="80px"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        class="blue"
                        size="small"
                        v-if="scope.row.type == 'over'"
                        @click="step4StoreRollback(scope.row, scope.$index)"
                        >撤销</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="flex-1 flex flex-center">
                <div
                  class="hmicon icon-youshuangjiantou1"
                  style="margin-top: 150px"
                ></div>
              </div>
            </div>
          </div>
          <div
            style="width: 35%"
            v-if="duplicateSolve < duplicateStoreList.length"
          >
            <div class="step2-Ms">{{ duplicateStoreList[0].storeName }}</div>
            <div class="mt10 flex">
              <div style="width: 90%">
                <div class="bs-ms primary-bg">新增上传的商户门店</div>
                <el-table
                  :data="step4AddShopList"
                  border
                  :height="500"
                  :row-class-name="tableRowClassNameStep4AddShop"
                  size="small"
                  style="width: 100%"
                >
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="shopName"
                    label="新增商户门店"
                  >
                    <template slot-scope="scope">
                      <div
                        style="padding-left: 20px"
                        @dblclick="changeEnddate(scope.$index, scope.row)"
                      >
                        <span v-show="scope.row.edit_enddate">{{
                          scope.row.shopName
                        }}</span>
                        <el-input
                          :ref="'enddateinput' + scope.$index"
                          @blur="enddateblur(scope.$index, scope.row)"
                          @keyup.enter.native="$event.target.blur"
                          clearable
                          v-show="!scope.row.edit_enddate"
                          size="mini"
                          style="width:100%"
                          v-model="scope.row.shopName"
                          placeholder="请输入内容"
                        ></el-input>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="shopAddress"
                    label="地址"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    width="80px"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        class="blue"
                        size="small"
                        v-if="scope.row.type"
                        @click="step4ShopRollback(scope.row, scope.$index)"
                        >撤销</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="flex-1 flex flex-center">
                <div
                  class="hmicon icon-youshuangjiantou1"
                  style="margin-top: 150px"
                ></div>
              </div>
            </div>
          </div>
          <div
            style="width: 35%;margin-top: 26px"
            v-if="duplicateSolve < duplicateStoreList.length"
          >
            <div class="flex flex-between item-center">
              <el-button
                type="primary"
                size="small"
                @click="duplicateShopViewAdd"
              >
                无匹配门店，点击新增</el-button
              >
              <el-input
                v-model="searchVal"
                size="small"
                placeholder="输入关键字搜索"
              />
            </div>
            <div>
              <div class="bs-ms bs-ms-has-bg mt10">已有的商户对应门店</div>
              <el-table
                :data="
                  likeRow.shops.filter(
                    data =>
                      !searchVal ||
                      data.shopName
                        .toLowerCase()
                        .includes(searchVal.toLowerCase()) ||
                      data.shopAddress
                        .toLowerCase()
                        .includes(searchVal.toLowerCase())
                  )
                "
                border
                :height="462"
                :row-class-name="tableRowClassNameStep4HaveShop"
                size="small"
                style="width: 100%"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="shopName"
                  label="已有商户对应门店"
                >
                  <template slot-scope="scope">
                    <div style="padding-left: 20px">
                      {{ scope.row.shopName }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="shopAddress"
                  label="地址"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="employeeCount"
                  label="导购数量"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="address"
                  label="操作"
                >
                  <template slot-scope="scope">
                    <div class="flex flex-center item-center">
                      <el-button
                        type="text"
                        size="small"
                        class="blue"
                        v-if="
                          scope.row.type != 'edit' && scope.row.type != 'new'
                        "
                        @click="duplicateShopViewEdit(scope.row, scope.$index)"
                      >
                        匹配
                      </el-button>
                      <div v-else class="gray" style="width:26px">
                        -- --
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
          <div
            class="flex-1"
            style="margin-top: 26px"
            v-if="duplicateSolve >= duplicateStoreList.length"
          >
            <div class="likeOver flex flex-center item-center">
              <div>
                <div class="text-center">
                  <img
                    src="https://imgcdn.hemiao100.com/ThemePictures/901144135.png"
                  />
                </div>

                <div style="font-size: 14px; color: #999999;">
                  当前页面商户已处理完毕，可以继续下一步操作
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="mt40 flex flex-center item-center">
          <el-button type="primary" size="small" @click="last(3)">
            上一步</el-button
          >
          <el-button
            type="primary"
            size="small"
            :disabled="duplicateSolve < duplicateStoreList.length"
            @click="submit"
          >
            提交</el-button
          >
        </div>
      </div>
      <el-drawer
        :title="likeList[0].storeName + ' / ' + likeRow.storeName"
        :visible.sync="catShopVisible"
        direction="rtl"
        v-if="step == 2 && likeList && likeList.length > 0"
        size="45%"
      >
        <div class="flex p20">
          <div class="mr20" style="width: 240px">
            <el-table
              :data="likeList[0].shops"
              border
              stripe
              size="small"
              style="width: 100%"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="55"
                :index="index => index + (currentPage - 1) * pageSize + 1"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="shopName"
                label="新增商户门店"
              >
              </el-table-column>
            </el-table>
          </div>
          <div class="flex-1">
            <el-table
              :data="likeRow.shops"
              border
              stripe
              size="small"
              style="width: 100%"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="55"
                :index="index => index + (currentPage - 1) * pageSize + 1"
              ></el-table-column>
              <el-table-column
                property="shopName"
                header-align="center"
                align="center"
                label="已有商户对应门店"
              >
              </el-table-column>
              <el-table-column
                property="employeeCount"
                header-align="center"
                align="center"
                label="导购数量"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </el-drawer>
      <el-dialog
        :visible.sync="dialogAct"
        width="1000px"
        title="活动详情"
        :close-on-click-modal="false"
      >
        <div>
          <el-table
            stripe
            :data="actList"
            border
            size="small"
            style="width: 100%"
          >
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
              :index="index => index + (currentPageAct - 1) * pageSizeAct + 1"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="store_name"
              label="供货商名称"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="reward_name"
              label="活动名称"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="reward_name"
              label="活动时间"
            >
              <template slot-scope="scope">
                {{ scope.row.reward_start_date }}至{{
                  scope.row.reward_end_date
                }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="150"
              header-align="center"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="actDetails(scope.row)"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="totalAct"
              @current-change="pagingAct"
              @size-change="handleSizeChangeAct"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="currentPageAct"
            ></el-pagination>
          </div>
        </div>
        <el-dialog
          width="1000px"
          title="活动详情"
          :visible.sync="innerVisible"
          append-to-body
        >
          <div class="flex flex-between mb10">
            <div class="flex-1">
              活动名称：{{ detailsSupplierBasicInfo.ruleInfo.rewardName }}
            </div>
            <div class="flex-1">
              活动下线：到期<span class="blue">{{
                detailsSupplierBasicInfo.ruleInfo.autoOfflineDaysLimt
              }}</span
              >天后自动下线
            </div>
            <div class="flex-1 flex flex-wrap">
              <div>
                适用时段：
              </div>

              <div
                class="flex flex-center blue"
                v-if="
                  detailsSupplierBasicInfo.ruleInfo.dateConfigMode === 'general'
                "
              >
                {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                  detailsSupplierBasicInfo.ruleInfo.rewardEndDate
                }}
              </div>
              <div
                class="flex flex-center blue"
                v-if="
                  detailsSupplierBasicInfo.ruleInfo.dateConfigMode === 'special'
                "
              >
                <div
                  v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'date'"
                >
                  {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                    detailsSupplierBasicInfo.ruleInfo.rewardEndDate
                  }}的每{{ detailsSupplierBasicInfo.ruleInfo.dateValue }}天
                </div>
                <div
                  v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'week'"
                >
                  {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                    detailsSupplierBasicInfo.ruleInfo.rewardEndDate
                  }}的
                  <span
                    v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo
                      .dateValue"
                    :key="i"
                  >
                    {{ i === 0 ? "" : "," }}每周{{ v }}</span
                  >
                </div>
                <div
                  v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'month'"
                >
                  {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                    detailsSupplierBasicInfo.ruleInfo.rewardEndDate
                  }}的
                  <span
                    v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo
                      .dateValue"
                    :key="i"
                  >
                    {{ i === 0 ? "" : "," }}每月{{ v }}号</span
                  >
                </div>
              </div>
            </div>
            <!-- <div class="flex-1">
            基础提成：
            <span
              v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
              class="primary"
            >
              ¥{{ detailsSupplierBasicInfo.ruleInfo.rewardValue }}</span
            >
            <span v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'">
              {{ detailsSupplierBasicInfo.ruleInfo.rewardValue }}%</span
            >
          </div>
          <div class="flex-1">
            活动条件：参与该活动的商品每满
            <span class="blue">{{
              detailsSupplierBasicInfo.ruleInfo.rewardNumberLimit
            }}</span>
            件为一组计算活动
          </div> -->
          </div>
          <div class="flex flex-between mb10">
            <div class="flex-1">
              适配组织：{{ detailsSupplierBasicInfo.ruleInfo.departNames }}
            </div>
            <div class="flex-1 flex-wrap ">
              活动备注：{{ detailsSupplierBasicInfo.ruleInfo.rewardRemark }}
            </div>
          </div>

          <div class="title mb10">
            适用商户:
            <span
              class="blue"
              v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo
                .applyStoreCodes"
              :key="i"
            >
              {{ i === 0 ? "" : "," }}{{ v }}</span
            >
          </div>
          <!-- <div class="table mb10">
          <el-table
            stripe
            ref="roleTable"
            :data="detailsSupplierBasicInfo.ruleInfo.applyStoreCodes"
            style="width: 100%"
            id="table"
            size="small"
            border
          >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="label"
              label="商户名称"
            >
              <template slot-scope="scope">
                {{ scope.row }}
              </template>
            </el-table-column>
          </el-table>
        </div> -->
          <div
            class="title mb10"
            v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
          >
            活动类型：普通活动
          </div>
          <div
            class="title mb10"
            v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub'"
          >
            活动类型：差异活动
          </div>
          <div
            class="title mb10"
            v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'"
          >
            活动类型：冲刺活动
          </div>
          <div class="title mb10">
            活动规则：
          </div>
          <div
            class="table mb10"
            v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
          >
            <el-table
              stripe
              ref="roleTable"
              :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
              style="width: 500px"
              border
              id="table"
              size="small"
            >
              <el-table-column type="index" label="序号"></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="每组件数"
                prop="rewardNumberLimit"
              >
                <template slot-scope="scope">
                  每满{{ scope.row.rewardNumberLimit }}件为一组
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="每组额外奖励"
                prop="rewardValue"
              >
                <template slot-scope="scope">
                  {{ scope.row.rewardValue }}元
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            class="table mb10"
            v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub'"
          >
            <el-table
              :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
              style="width: 100%"
              ref="table"
              stripe
              size="small"
              :show-header="showHeader"
            >
              <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="start"
                label="每组件数"
                width="700"
                prop="rewardNumberLimit"
              >
                <template slot-scope="scope">
                  买
                  {{ scope.row.rewardNumberLimit }}
                  件, 送
                  {{ scope.row.rewardSubNum }}
                  件,{{
                    new Number(scope.row.rewardNumberLimit) +
                      new Number(scope.row.rewardSubNum)
                  }}件为一组，发放
                  {{ scope.row.rewardNumberLimit }}件商品的单件奖励,
                  每组额外奖励
                  {{ scope.row.rewardValue }}
                  元
                </template>
              </el-table-column>

              <!-- <el-table-column
                  header-align="center"
                  align="center"
                  label="操作"
                  width="100"
                >
                  <template slot-scope="scope">
                    <div>
                      <el-button
                        v-if="scope.$index === 0"
                        size="small"
                        @click="addChild(scope.$index)"
                        type="text"
                        >新 增</el-button
                      >
                      <el-button
                        v-else
                        size="small"
                        @click="delRule(scope.$index)"
                        class="danger"
                        type="text"
                        >删 除</el-button
                      >
                    </div>
                  </template>
                </el-table-column> -->
            </el-table>
          </div>
          <div
            class="table mb10"
            v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'"
          >
            <el-table
              stripe
              ref="roleTable"
              :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
              style="width: 500px"
              border
              id="table"
              size="small"
            >
              <el-table-column type="index" label="序号"></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="冲刺门槛"
                prop="rewardNumberLimit"
              >
                <template slot-scope="scope">
                  {{ scope.row.rewardNumberLimit }}件
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="额外奖励"
                prop="rewardValue"
              >
                <template slot-scope="scope">
                  每件额外奖励{{ scope.row.rewardValue }}元
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="title mb10">
            适用商品
          </div>
          <div class="table mb10">
            <el-table
              stripe
              ref="roleTable"
              :data="detailsSupplierBasicInfo.goodsList"
              style="width: 100%"
              id="table"
              size="small"
              border
            >
              <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="brandName"
                label="商品品牌"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsName"
                label="商品名称"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsBarcode"
                label="商品条码"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="rewardBaseMoney"
                label="单件奖励"
                v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub'"
              >
              </el-table-column>
            </el-table>
          </div>
          <div class="flex flex-center">
            <el-button size="small" type="primary" @click="innerVisible = false"
              >确认</el-button
            >
          </div>
        </el-dialog>
      </el-dialog>
    </hm-content>
  </div>
</template>

<script>
import HmStep from "@/components/HmStep";
import { mapGetters } from "vuex";
export default {
  components: { HmStep },
  data() {
    return {
      list: [],
      duplicateStoreList: [],
      notExistStoreList: [],
      likeList: [
        {
          shops: []
        }
      ],
      likeStoreList: [],
      duplicateAddShopList: [],
      duplicateHaveShopList: [],
      likeSolve: 0,
      duplicateSolve: 0,
      duplicateAddTotal: 0,
      duplicateAddSolve: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      steps: [
        {
          link: "ImportMerchantManage",
          name: "与已有商户名称一致"
        },
        {
          link: "ImportMerchantManage",
          name: "与已有商户名称相似"
        },
        {
          link: "ImportMerchantManage",
          name: "与已有商户名称不一致"
        },
        {
          link: "ImportMerchantManage",
          name: "已匹配商户门店核对确认"
        }
      ],
      step: 1,
      title: "",
      catShopVisible: false,
      likeRow: {
        shops: []
      },
      likeRowShopList: [],
      row: {},
      editwxName: "",
      shopRow: {},
      currentPageAct: 1,
      pageSizeAct: 10,
      actRow: {},
      dialogAct: false,
      actList: [],
      totalAct: 0,
      innerVisible: false,
      oldDuplicateStoreList: [],
      oldNotExistStoreList: [],
      step4AddShopList: [],
      step4LikeRow: {},
      searchVal: "",
      submitDataList: []
    };
  },
  computed: mapGetters(["detailsSupplierBasicInfo"]),
  created() {
    this.queryList();
    this.getTitleInfo();
  },
  mounted() {},
  methods: {
    //导出
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["新增商户", "已有商户"];
        let filterVal = ["addStore", "hasStore"];
        let list = [];
        let index =
          this.notExistStoreList.length >= this.duplicateStoreList.length
            ? this.notExistStoreList.length
            : this.duplicateStoreList.length;
        for (let i = 0; i < index; i++) {
          let addStore = "";
          let hasStore = "";
          console.log("notExistStoreList", this.notExistStoreList);
          console.log("duplicateStoreList", this.duplicateStoreList);
          if (this.notExistStoreList.length - 1 >= i) {
            addStore = this.notExistStoreList[i].storeName;
          }
          if (this.duplicateStoreList.length - 1 >= i) {
            hasStore = this.duplicateStoreList[i].oldStoreName;
          }
          list.push({
            addStore,
            hasStore
          });
        }
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(tHeader, data, "红包商户");
      });
    },
    submitOutput() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = ["商户名", "门店名"];
        let filterVal = ["storeName", "shopName"];
        let list = [];
        this.submitDataList.forEach(v => {
          v.allShops.forEach(item => {
            list.push({
              storeName: v.storeName,
              shopName: item.shopName
            })
          })
        })
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(tHeader, data, "红包商户");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    pagingAct(page) {
      this.currentPageAct = page;
      this.queryActList();
    },
    handleSizeChangeAct(size) {
      this.currentPageAct = 1;
      this.pageSizeAct = size;
      this.queryActList();
    },
    actDetails(row) {
      this.innerVisible = true;
      this.$store.dispatch("detailsSupplierRewardRuleInfoList", {
        rewardRuleId: row.reward_rule_id
      });
    },
    async queryActList() {
      let params = {
        pageSize: this.pageSizeAct,
        pageNo: this.currentPageAct,
        storeCode: this.actRow.storeCode
      };
      // const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      // searchCondition.createTimeStart =
      //   this.searchCondition.date && this.searchCondition.date.length > 0
      //     ? this.searchCondition.date[0]
      //     : "";
      // searchCondition.createTimeEnd =
      //   this.searchCondition.date && this.searchCondition.date.length > 0
      //     ? this.searchCondition.date[0]
      //     : "";

      // Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryStoreRewardList",
        params
      );
      this.actList = result.records;
      this.totalAct = result.total;
    },
    //查看活动数
    goAct(row) {
      // localStorage.setItem("storeName", row.storeName);
      // this.$router.push({
      //   name: "ActivityManagement",
      //   query: {
      //     storeCode: row.storeCode
      //   }
      // });
      this.currentPageAct = 1;
      this.pageSizeAct = 10;
      this.actRow = row;
      this.queryActList();
      this.dialogAct = true;
    },
    //路由跳转
    toUrl(url) {
      this.$router.push({
        name: url
      });
    },

    //--------------step4操作------------------------
    //门店撤销
    step4ShopRollback(row, index) {
      this.duplicateAddSolve--;
      row.type = "";
      row.shopName = row.oldShopName;
      this.likeRow.shops.forEach((v, i) => {
        if (v.shopId == row.shopId) {
          v.type = "";
          this.likeRow.shops.unshift(this.likeRow.shops.splice(i, 1)[0]);
        }
      });
      this.step4AddShopList.unshift(this.step4AddShopList.splice(index, 1)[0]);
    },
    //商户撤销
    step4StoreRollback(row, index) {
      this.duplicateSolve--;
      row.type = "";
      this.duplicateStoreList.unshift(
        this.duplicateStoreList.splice(index, 1)[0]
      );
      this.duplicateAddShopList.forEach((v, i) => {
        if (row.storeCode == v.storeCode) {
          this.duplicateAddShopList.splice(i, 1);
        }
      });
      this.step4CheckoutStore();
    },
    //第四步商户切换
    step4CheckoutStore() {
      this.step4LikeRow = JSON.parse(
        JSON.stringify(this.duplicateStoreList[0])
      );
      this.likeRow = JSON.parse(JSON.stringify(this.duplicateStoreList[0]));
      this.step4AddShopList = JSON.parse(
        JSON.stringify(this.step4LikeRow.shops)
      );
      let params = {
        storeCode: this.step4LikeRow.storeCode,
        storeName: this.step4LikeRow.storeName
      };
      this.step4AddShopList.forEach(v => {
        v.edit_enddate = true;
        v.oldShopName = v.shopName;
      });
      this.duplicateAddSolve = 0;
      this.duplicateAddTotal = this.step4AddShopList.length;
      this.getShop(params, false);
    },
    //已有商户门店新增
    duplicateShopViewAdd() {
      this.duplicateAddSolve++;
      this.step4AddShopList[0].type = "new";
      const [first, ...rest] = this.step4AddShopList;
      this.step4AddShopList = [...rest, first];
      this.$message({
        message: "新增成功！",
        type: "success"
      });
      if (this.duplicateAddSolve >= this.step4AddShopList.length) {
        this.duplicateSolve++;
        this.duplicateStoreList[0].type = "over";
        const [storeFirst, ...storeRest] = this.duplicateStoreList;
        this.duplicateStoreList = [...storeRest, storeFirst];

        let item = JSON.parse(JSON.stringify(this.step4LikeRow));
        let shops = [];
        this.step4AddShopList.forEach(v => {
          if (v.type == "new") {
            shops.push(v);
          }
        });
        item.shops = shops;
        item.allShops = this.step4AddShopList;
        this.duplicateAddShopList.push(item);

        this.step4CheckoutStore();
      }
    },
    //已有商户门店匹配
    duplicateShopViewEdit(row, index) {
      this.duplicateAddSolve++;
      this.step4AddShopList[0].shopName = row.shopName;
      this.step4AddShopList[0].shopAddress = row.shopAddress;
      this.step4AddShopList[0].shopId = row.shopId;
      this.step4AddShopList[0].type = "edit";
      const [first, ...rest] = this.step4AddShopList;
      this.step4AddShopList = [...rest, first];
      this.likeRow.shops[index].type = "edit";
      this.likeRow.shops.push(this.likeRow.shops.splice(index, 1)[0]);
      this.$message({
        message: "匹配成功！",
        type: "success"
      });
      if (this.duplicateAddSolve >= this.step4AddShopList.length) {
        this.duplicateSolve++;
        this.duplicateStoreList[0].type = "over";
        const [storeFirst, ...storeRest] = this.duplicateStoreList;
        this.duplicateStoreList = [...storeRest, storeFirst];

        let item = JSON.parse(JSON.stringify(this.step4LikeRow));
        let shops = [];
        this.step4AddShopList.forEach(v => {
          if (v.type == "new") {
            shops.push(v);
          }
        });
        item.shops = shops;
        item.allShops = this.step4AddShopList;
        this.duplicateAddShopList.push(item);

        this.step4CheckoutStore();
      }
    },
    enddateblur(index, rowdata) {
      if (rowdata.storeName === "" || rowdata.storeName === this.editwxName) {
        rowdata.storeName = this.editwxName;
        this.step4AddShopList = [...this.step4AddShopList];
      } else {
        this.duplicateStoreList.shops[index].storeName = rowdata.storeName;
      }
      this.step4AddShopList[index].edit_enddate = !this.step4AddShopList[index]
        .edit_enddate;
    },
    changeEnddate(index, rowdata) {
      if (rowdata.type) {
        return;
      }
      this.editwxName = rowdata.storeName;
      this.step4AddShopList[index].edit_enddate = !this.step4AddShopList[index]
        .edit_enddate; //直接加key
      this.step4AddShopList = [...this.step4AddShopList];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs["enddateinput" + index].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    //--------------end------------------------

    //--------------step2操作------------------------
    //第二步撤销
    step2Rollback(row, index) {
      this.likeSolve--;
      this.row = row;
      this.likeList.splice(index, 1);
      this.row.type = "";
      this.row.storeName = this.row.oldStoreName;
      this.likeList.unshift(this.row);
      this.getLikeStore();
    },
    //获取相似的商户
    async getLikeStore() {
      let params = [];
      params.push(this.likeList[0]);
      const { result } = await this.$store.dispatch(
        "redPackAgeGetLikeStore",
        params
      );
      this.likeStoreList = result.likeStores[0].likes;
    },
    //相似数据新增
    likeViewAdd() {
      this.likeSolve++;
      this.row = this.likeList[0];
      this.row.type = "new";
      this.likeList.splice(0, 1);
      this.likeList.push(this.row);
      this.getLikeStore();
      this.$message({
        message: "新增成功！",
        type: "success"
      });
    },
    //相似数据匹配
    likeViewEdit(row) {
      this.likeSolve++;
      this.row = this.likeList[0];
      this.row.storeName = row.storeName;
      this.row.storeCode = row.storeCode;
      this.row.type = "edit";
      this.likeList.splice(0, 1);
      this.likeList.push(this.row);
      this.getLikeStore();
      this.$message({
        message: "匹配成功！",
        type: "success"
      });
    },
    //查看门店
    catShop(row) {
      this.likeRow = row;
      let params = {
        storeCode: this.likeRow.storeCode,
        storeName: this.likeList[0].storeName
      };
      this.getShop(params, true);
    },
    async getShop(params, flag) {
      const { result } = await this.$store.dispatch(
        "redPackageCatShops",
        params
      );
      console.log(result);
      this.likeRow.shops = result.existShops;
      if (flag) {
        this.catShopVisible = true;
      }
    },
    //--------------end------------------------

    //--------------获取table样式------------------------
    //获取table的行样式
    tableRowClassName({ row, rowIndex }) {
      let str = "";
      if (this.step == 2) {
        if (row.type == "edit") {
          str = "piPei";
        } else if (row.type == "new") {
          str = "xinZeng";
        }
        if (rowIndex === 0 && row.type != "edit" && row.type != "new") {
          str = str + " selectTableStyle";
        } else {
          str = str + " notSelectTableStyle";
        }
      } else {
        if (row.type == "over") {
          str = "chuLi";
        }
        if (this.duplicateSolve < this.duplicateStoreList.length) {
          if (rowIndex === 0) {
            str = str + " selectTableStyle";
          } else {
            str = str + " notSelectTableStyle";
          }
        } else {
          str = str + " notSelectTableStyle";
        }
      }
      return str;
    },
    //step4的新增门店行样式
    tableRowClassNameStep4AddShop({ row, rowIndex }) {
      let str = "";
      if (row.type == "edit") {
        str = "piPei";
      } else if (row.type == "new") {
        str = "xinZeng";
      }
      if (rowIndex === 0 && row.type != "edit" && row.type != "new") {
        str = str + " selectTableStyle";
      } else {
        str = str + " notSelectTableStyle";
      }
      return str;
    },
    //step4的已有门店行样式
    tableRowClassNameStep4HaveShop({ row, rowIndex }) {
      let str = "";
      if (row.type == "edit") {
        str = "piPei";
      } else if (row.type == "new") {
        str = "xinZeng";
      }
      return str;
    },
    //--------------end------------------------

    //--------------上一步下一步按钮操作------------------------
    //提交
    async submit() {
      let params = [];
      this.notExistStoreList.forEach(v => {
        v.allShops = v.shops;
      })
      params.push(...this.notExistStoreList);
      params.push(...this.duplicateAddShopList);
      this.submitDataList = params;
      this.$confirm('是否需要导出最终导入系统的商户和门店信息, 以方便后续操作?', '提示', {
        confirmButtonText: '导出数据',
        cancelButtonText: '暂不需要',
        type: 'warning'
      }).then(() => {
        this.submitOutput();
      }).catch(() => {

      });
      console.log("submit", params);
      await this.$store.dispatch('redPackageSaveBatchStoreList', params);
      this.toUrl("MerchantList");
    },
    //上一步
    last(step) {
      this.step = step;
      this.getTitleInfo();
      if (step == 2) {
        this.duplicateStoreList = JSON.parse(
          JSON.stringify(this.oldDuplicateStoreList)
        );
        this.notExistStoreList = JSON.parse(
          JSON.stringify(this.oldNotExistStoreList)
        );
        this.duplicateSolve = 0;
        this.duplicateAddShopList = [];
      }
      if (step == 3) {
        this.duplicateStoreList.forEach(v => {
          if (v.type != "over") {
            v.shops.forEach(item => {
              item.type = "";
            });
          }
        });
      }
    },
    //下一步
    next(step) {
      this.step = step;
      this.getTitleInfo();
      if (step == 2 && this.likeList && this.likeList.length > 0) {
        this.likeStoreList = this.likeList[0].likes;
      }
      if (step == 3) {
        //计算新增和匹配的商户
        this.clacStore();
      }
      if (step == 4) {
        this.step4CheckoutStore();
      }
    },
    //计算新增和匹配的商户
    clacStore() {
      this.likeList.forEach(v => {
        if (v.type == "new") {
          this.notExistStoreList.push(v);
        } else if (v.type == "edit") {
          this.duplicateStoreList.push(v);
        }
      });
    },
    //获取title信息
    getTitleInfo() {
      this.title = this.steps[this.step - 1].name;
    },
    //--------------end------------------------

    //--------------初始化------------------------
    async queryList() {
      let list = JSON.parse(
        sessionStorage.getItem("redPackageImportStoreList")
      );
      const { code, result } = await this.$store.dispatch(
        "preImportStore",
        list
      );
      if (code === "0") {
        //保留原始数据
        this.oldDuplicateStoreList = JSON.parse(
          JSON.stringify(result.duplicateStores)
        );
        this.oldNotExistStoreList = JSON.parse(
          JSON.stringify(result.notExistStores)
        );
        //展示数据

        result.duplicateStores.forEach(v => {
          v.oldStoreName = v.storeName;
        });
        this.duplicateStoreList = result.duplicateStores;
        result.likeStores.forEach(v => {
          v.oldStoreName = v.storeName;
        });
        this.likeList = result.likeStores;
        this.notExistStoreList = result.notExistStores;
      }
    },
    //--------------end------------------------

    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>
<style lang="scss">
.selectTableStyle {
  background-color: #fedeec !important;
  color: #e50065;
}
.notSelectTableStyle {
  color: #999999;
}
.chuLi {
  background-image: url(https://imgcdn.hemiao100.com/ThemePictures/_20210902171551.png);
  background-size: 40px;
  background-repeat: no-repeat;
  background-position: 0 0;
}
.piPei {
  background-image: url(https://imgcdn.hemiao100.com/ThemePictures/_20210902165718.png);
  background-size: 40px;
  background-repeat: no-repeat;
  background-position: 0 0;
}
.xinZeng {
  background-image: url(https://imgcdn.hemiao100.com/ThemePictures/_20210902165726.png);
  background-size: 40px;
  background-repeat: no-repeat;
  background-position: 0 0;
}
</style>
<style scoped lang="scss">
.bg {
  background-color: #fff;
  .ms {
    padding: 20px 20px 0px;
    font-size: 14px;
    color: #999999;
  }
}
/deep/ .el-table__body tr:hover > td {
  background-color: transparent;
}
.title {
  color: rgba(34, 34, 34, 1);
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 16px;
  &::before {
    display: inline-block;
    margin-right: 5px;
    content: "";
    width: 3px;
    height: 14px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.step2-Ms {
  font-size: 16px;
}
.likeOver {
  height: 319px;
  border: 1px solid #dddddd;
}
.bs-ms {
  height: 40px;
  color: #fff;
  text-align: center;
  line-height: 40px;
}
.bs-ms-has-bg {
  background-color: #0081e5;
}
</style>
